import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowDurationSchemaWithMax } from '../../../duration/withMax.js';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { FlowBlockValueEmailSchema } from '../../blockValue/emailSchema.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowSendEmailBlockConfigSchema = z.object({
    senderEmail: FlowBlockValueEmailSchema({ isRequired: true }),
    senderName: z.string().min(1, 'This field is required.'),
    recipientEmail: FlowBlockValueEmailSchema({ isRequired: true }),
    subject: z.string().min(1, 'This field is required.'),
    content: z.string().min(1, 'This field is required.'),
    timeout: FlowDurationSchemaWithMax({
        pathName: 'timeout',
        max: { value: 1, units: FlowDurationUnits.Hours },
    }),
});
export const FlowSendEmailBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.SendEmail),
    config: FlowSendEmailBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.SendEmail),
});
//# sourceMappingURL=config.js.map